import {
  ADD_TEAM_REQUEST,
  ADD_TEAM_SUCCESS,
  DELETE_TEAM_MEMBER_FAIL,
  DELETE_TEAM_MEMBER_REQUEST,
  DELETE_TEAM_MEMBER_SUCCESS,
  EDIT_TEAM_FAIL,
  EDIT_TEAM_REQUEST,
  EDIT_TEAM_SUCCESS,
  GET_TEAM_DETAIL_REQUEST,
  GET_TEAM_DETAIL_SUCCESS,
  GET_TEAM_FAIL,
  GET_TEAM_LIST_DATA_FAIL,
  GET_TEAM_LIST_DATA_REQUEST,
  GET_TEAM_LIST_DATA_SUCCESS,
  GET_TEAM_REQUEST,
  GET_TEAM_SUCCESS,
} from "../constant";

const initialState = {
  teamData: [],
  totalRecords: null,
  addTeamFormData: {},
  teamDetail: null,
  teamMembers: [],
  isAddingTeam: false,
  teamDataLoading: false,
  isDeleteUser: false,
};

const teamReducer = (state = initialState, action) => {
  switch (action.type) {
    //Get survey
    case GET_TEAM_REQUEST:
      return {
        ...state,
        teamData: [],
        totalRecords: null,
        teamDataLoading: true,
      };
    case GET_TEAM_SUCCESS:
      return {
        ...state,
        teamData: action.payload?.data,
        totalRecords: action.payload?.totalRecords,
        teamDataLoading: false,
      };
    case GET_TEAM_FAIL:
      return {
        ...state,
        teamData: [],
        totalRecords: null,
        teamDataLoading: false,
      };

    //Get survey list data
    case GET_TEAM_LIST_DATA_REQUEST:
      return {
        ...state,
      };
    case GET_TEAM_LIST_DATA_SUCCESS:
      const listData = action.payload;
      let tmpList = state?.teamData?.map((TEAM) => ({
        ...TEAM,
        ...listData[TEAM.TEAM_id],
      }));
      return {
        ...state,
        teamData: [...tmpList],
      };
    case GET_TEAM_LIST_DATA_FAIL:
      return {
        ...state,
      };

    case GET_TEAM_DETAIL_REQUEST:
      return {
        ...state,
      };

    case GET_TEAM_DETAIL_SUCCESS:
      const team = action.payload;
      console.log("team", team);
      return {
        ...state,
        teamDetail: team.data,
        teamMembers: team.teamMembers,
      };

    case ADD_TEAM_REQUEST:
      return {
        ...state,
        isAddingTeam: true,
      };
    case ADD_TEAM_SUCCESS:
      return {
        ...state,
        isAddingTeam: false,
      };
    case EDIT_TEAM_REQUEST:
      return {
        ...state,
        isAddingTeam: true,
      };
    case EDIT_TEAM_SUCCESS:
      return {
        ...state,
        isAddingTeam: false,
      };
    case EDIT_TEAM_FAIL:
      return {
        ...state,
        isAddingTeam: false,
      };

    case DELETE_TEAM_MEMBER_REQUEST:
      return {
        ...state,
        isDeleteUser: true,
      };
    case DELETE_TEAM_MEMBER_FAIL:
      return {
        ...state,
        isDeleteUser: false,
      };
    case DELETE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        isDeleteUser: false,
      };
    default:
      return state;
  }
};

export { teamReducer };
